import React,{useState} from 'react'
import '../Css/Registry.css';
import '../App.css';
import axios from 'axios';
import {toast} from "react-toastify";
import { useNavigate } from 'react-router-dom';
import clipboard from '../icon/icons8-clipboard-100.png';



function Registry() {
  //navigation
  const navigate = useNavigate();

  //currentDate 
  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0];
  let regDate = formattedDate;
  
  const [phone,setPhone] = useState('');
  const [chineseName,setChineseName] = useState('');
  const [name,setName] = useState('');
  const [nickName,setNickName] = useState('');
  const [gender,setGender] = useState('');
  const [email,setEmail] = useState('');
  const [idNumber,setIdNumber] = useState('');
  const [dateOfBirth,setDateOfBirth] = useState('');
  const [address,setAddress] =useState('');
  const [occupation,setOccupation] = useState('');
  const [accountName,setAccountName] = useState('');
  const [accountNumber,setAccountNumber] = useState('');
  const [FTPName,setFTPName] = useState('');
  const [FTPNumber,setFTPNumber] = useState('');

  //data store
  const [data,setData] = useState('');

  //agreement check box
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  function handleSubmit(e){
    e.preventDefault();  

    if(isChecked ===true){
          

      //clean phone number,remove all numerical value
      const cleanedPhoneNum = phone.replace(/[^\d]/g, '').slice(0, 8);
      //check the start of number
      //^ start of number
      //[23569] -First digit must be 
      //d{7} -followed by 7 digit
      const valid = /^[23569]\d{7}$/.test(cleanedPhoneNum);
      console.log("Valid PhoneNum", valid);

      //valid phone number checked
      if (valid) {
        console.log('valid phone submitted !');
        connectPhp();
      }else{
        toast.error("請輸入有效電話號碼..",{
          position:"top-center",
        });      
        console.log('Please enter a valid telephone number ');
      }  
    }else{
      console.log('you have to sign the agreement');
      toast.error("必須同意本會條款..",{
        position:"top-center",
      });      
    }
  }  
  
  function handlePhoneChange(e){
    const value =e.target.value;
    setPhone(value);
  }
  

  function handleChineseNameChange(e){
    const value = e.target.value;
    setChineseName(value);
  }

  function handleEnglishNameChange(e){
    const value = e.target.value;
    setName(value);
  }

  function handleOtherNameChange(e){
    const value = e.target.value;
    setNickName(value);
  }

  function handleGenderChange(e){
    const value = e.target.value;
    setGender(value);
  }

  function handleEmailChange(e){
    const value = e.target.value;
    setEmail(value);
  }

  function handleIdNumChange(e){
    const value = e.target.value;
    setIdNumber(value);
  }

  function handleBirthDateChange(e){
    const value = e.target.value;
    setDateOfBirth(value);
  }

  function handleAddressChange(e){
    const value = e.target.value;
    setAddress(value);
  }

  function handleOccupationChange(e){
    const value = e.target.value;
    setOccupation(value);
  }

  function handleBankNameChange(e){
    const value = e.target.value;
    setAccountName(value);
  }

  function handleAccountNumChange(e){
    const value = e.target.value;
    setAccountNumber(value);
  }

  function handleFPSNameChange(e){
    const value = e.target.value;
    setFTPName(value);
  }

  function handleFPSNumChange(e){
    const value = e.target.value;
    setFTPNumber(value);
  }

  //php api server
  function connectPhp(){
    let data = [];
    const url="https://pta-hk.com/ptahk-regProcess.php";
    let fData =new FormData();
    fData.append('regDate',regDate);
    fData.append('gender',gender);
    fData.append('phone',phone);
    fData.append('email',email);
    fData.append('name',name);
    fData.append('idNumber',idNumber);
    fData.append('nickName',nickName);
    fData.append('accountName',accountName);
    fData.append('accountNumber',accountNumber);
    fData.append('FTPName',FTPName);
    fData.append('FTPNumber',FTPNumber);
    fData.append('chineseName',chineseName);
    fData.append('address',address);
    fData.append('dataOfBirth',dateOfBirth);
    fData.append('occupation',occupation);
      
    axios.post(url,fData).then
      (response=>{
            data = response.data;
            setData(data);
            console.log("Result Data",data);
            if(data ==="regSuccess"){
              //navigate to Reg Comfirm component
              navigate('/RegConfirm');

            }
      }).catch((e)=>console.log(e));
      
  }


  
  return (
    <div className="container">
      <div className="container-content">
        <div className="registry-content">
          <div className="title">會員註冊 &nbsp;&nbsp;
            <img src={clipboard}
              alt="Poker Tournament Association"
              className="icon"
            />


          </div>
          <div className="panel">
             <h3>個人資料</h3>
             <p>PTTA Poker Association(下稱「本會」)將收集你的個人資料，作為有關申請服務的用途。本會可將你的個人資料，包括但不限於姓名、電話號碼、電郵地址、郵寄地址等，向工作上有需要知道該等資料的協會職員、獲授權或有法定權力收取有關資料的政府部門或機構、及獲協會委任的法律顧問及/或其他服務提供者等轉移及披露。有關的個人資料將按《個人資料 ( 私隱 ) 條例 》處理，不會以任何形式出售、租借或轉讓予任何人士或組織。</p>
              <p>* -必須填寫項目</p>
          </div>
          <form onSubmit = {handleSubmit} className="registry-form">
                    <div className="booking-form-group">
                         <div className="form-notice">
                            *必須墳寫
                        </div>
                    </div>

                      {/**** Registry Date */}
                        <div className="registry-form-group">
                          <label>註冊日期 :</label>&nbsp;&nbsp;
                          <label>{regDate}</label>
                        </div>

                      {/******** Chinese Name ******/}  
                       <div className="registry-form-group">
                          <label>中文姓名-需與身份證相同*:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              required
                              type="text"
                              id="chineseName"
                              value={chineseName}
                              onChange={handleChineseNameChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px',
                                  width:'100px',
                                  backgroundColor:"#e0e0e0"
                              }}
                          />
                        </div>

                       {/******** English Name ******/}  
                       <div className="registry-form-group">
                          <label>英文姓名-需與身份證相同*:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              required
                              type="text"
                              id="name"
                              value={name}
                              onChange={handleEnglishNameChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px',
                                  width:'100px',
                                  backgroundColor:"#e0e0e0" 
                              }}
                          />
                        </div>  

                      {/********** other name input *****/}
                        <div className="registry-form-group">
                          <label>稱呼&nbsp;:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              type="text"
                              id="nickName"
                              value={nickName}
                              onChange={handleOtherNameChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px',
                                  width:'100px',
                                  backgroundColor:"#e0e0e0" 
                              }}
                          />
                        </div>

                      {/************ Gender ****************/} 
                        <div className="registry-form-group">
                          <label>
                            <input
                              type="radio"
                              value="男"
                              checked={gender=== '男'}
                              onChange={handleGenderChange}
                            />
                            男性
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="女"
                              checked={gender==='女'}
                              onChange={handleGenderChange}
                            />
                            女性
                          </label>
                        </div>      
      
                      {/********** Phone Input *****/}
                        <div className="registry-form-group">
                          <label>聯絡電話&nbsp;*:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              type="text"
                              maxLength={8}
                              id="phone"
                              value={phone}
                              onChange={handlePhoneChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px',
                                  width:'100px',
                                  backgroundColor:"#e0e0e0" 
                              }}
                          />
                        </div>

                      {/********** Email Input *****/}
                        <div className="registry-form-group">
                          <label>電郵&nbsp;*:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              type="email"
                              id="email"
                              value={email}
                              onChange={handleEmailChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  width:'100px',
                                  backgroundColor:"#e0e0e0"
                              }}
                          />
                        </div>  

                      {/********** Id Card Input *****/}
                        <div className="registry-form-group">
                          <label>身份證首4位號碼(包括英文字母)&nbsp;*:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              type="text"
                              id="idNumber"
                              maxLength={4}
                              value={idNumber}
                              onChange={handleIdNumChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  width:'100px',
                                  backgroundColor:"#e0e0e0"
                              }}
                          />
                        </div>

                       {/********** Birthday Input *****/}
                        <div className="registry-form-group">
                          <label>出生日期 (yyyy/mm/dd) &nbsp;*:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              type="text"
                              id="dateOfBirth"
                              value={dateOfBirth}
                              onChange={handleBirthDateChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  width:'100px',
                                  backgroundColor:"#e0e0e0"
                              }}
                          />
                        </div>      

                        {/********** address Input *****/}
                        <div className="registry-form-group">
                          <label>住址&nbsp;:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              type="text"
                              id="address"
                              value={address}
                              onChange={handleAddressChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  width:'200px',
                                  backgroundColor:"#e0e0e0"
                              }}
                          />
                        </div>      

                      {/********** occupation Input *****/}
                        <div className="registry-form-group">
                          <label>職業&nbsp;:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              type="text"
                              id="occupation"
                              value={occupation}
                              onChange={handleOccupationChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  width:'100px',
                                  backgroundColor:"#e0e0e0"
                              }}
                          />
                        </div>

                      {/********** bank account name Input *****/}
                        <div className="registry-form-group">
                          <label>銀行名稱&nbsp;:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              type="text"
                              id="accountName"
                              value={accountName}
                              onChange={handleBankNameChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  width:'100px',
                                  backgroundColor:"#e0e0e0"
                              }}
                          />
                        </div>  
                      {/********** bank account number Input *****/}
                        <div className="registry-form-group">
                          <label>銀行號碼&nbsp;:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              type="text"
                              id="accountNumber"
                              value={accountNumber}
                              onChange={handleAccountNumChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  width:'100px',
                                  backgroundColor:"#e0e0e0"
                              }}
                          />
                        </div>
                    {/********** FTP name Input *****/}
                        <div className="registry-form-group">
                          <label>FPS名稱&nbsp;:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              type="text"
                              id="FTPName"
                              value={FTPName}
                              onChange={handleFPSNameChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  width:'100px',
                                  backgroundColor:"#e0e0e0"
                              }}
                          />
                        </div>                  
                      {/********** FPS Num Input *****/}
                        <div className="registry-form-group">
                          <label>FPS號碼&nbsp;:</label>&nbsp;&nbsp;
                          <input className="form-input"
                              type="text"
                              id="FTPNumber"
                              value={FTPNumber}
                              onChange={handleFPSNumChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px',
                                  width:'100px',
                                  backgroundColor:"#e0e0e0" 
                              }}
                          />
                        </div>                   
           
                        

                        <div className="panel">
            <h3>PTA Poker Tournament Association 會員守則</h3>
            <h4>本會之所有會員(下稱「會員」)均有約束力。</h4>
            <ul className="list-group">
              <li className="list-group-item">
                  1.本會提倡德州撲克競技化、德州撲克技術交流為主，凡申請本會會籍之會員身份使用本會服務及設施之人士，即表示支持上述之本會宗旨及同意受本會員守則(包括不時生效之條款及條件)約束。
              </li>
              <li className="list-group-item">
                  2.所有會籍申請須經本會批准，本會有絕對酌情權批准或不批准有關申請而無須作任何解釋。
              </li>
              <li className="list-group-item">
                  3.本會之會籍不得轉讓。
              </li>
              <li className="list-group-item">
                  4.會員會籍申請被本會接納後，會員可透過本會的應用程式確認會員證。會員證在任何情況下均為本會之財物，本會有權隨時撤銷該證之效力及/終止會員之會籍而無須給予任何理由。本會亦有權要求會員歸還會員證予本會。
              </li>
              <li className="list-group-item">
                  5.會員證只供獲發該證之會員使用，不得轉讓。會員於享用本會所提供之服務及設施時，須出示會員證作為其會籍的證明。
              </li>
              <li className="list-group-item">
                  6.會員於被批准入會後，即有資格接受及享用本會提供之服務及設施，惟須接受本會於提供該等服務及設施時訂明之任何特定條款及條件限制。
              </li>
              <li className="list-group-item">
                  7.本會有絕對酌情權隨時終止任何服務或設施之提供及/或其運作，而無須向會員發出通知或給予任何理由。
              </li>
              <li className="list-group-item">
                  8.經本會書面同意，會員不得利用本會或本會提供之服務、設施、資料或文件作任何商業、不道德或不合法用途。
              </li>
              <li className="list-group-item">
                  9.本會嚴禁會員於本會進行任何與賭博有關的行為。 
              </li>
              <li className="list-group-item">
                  10.會員在場內嚴禁從事推銷或介紹個人業務等行為。
              </li>
              <li className="list-group-item">    
                  11.為保障會員的個人隱私及利益，嚴格禁止會員交換電話號碼。
              </li>
              <li className="list-group-item">
                  12.所有會員積分提取均需以身份証核實, 不能代辦。
              </li>
              <li className="list-group-item">
                  13.本會倘若認爲任何會員之行爲對本會有損或與本會之利益相違或違反任何會員守則，本會可終止有關會員於本會之會籍，而本會之決定爲最後及終局性的。被終止會籍之會員將停止享有會籍所授予之任何權利、福利或優惠，而且不再有權接受及享用本會提供之服務及設施。被終止會籍之會員於收到終止會籍之通知後須立即向本會交還會員證。
              </li>   
              <li className="list-group-item">
                  14.本會無須為任何因會員之會籍或與會籍關連而直接或間接導致或引起任何性質之損失、索償、費用、收費或支出，向任何會員或任何其他人士承擔責任或法律責任。
              </li>
              <li className="list-group-item">
                  15.本會有絕對酌情權不時更改本會員守則，並以其認爲合適之任何方式通知會員任何上 述之更改。除非會員證在更改生效並載明於向會員通知之日期前被歸還本會以便註銷，否則 會員須受該等已更改之守則約束。
              </li>
              <li className="list-group-item">
                  16.本守則受香港特別行政區法律管轄並按香港特別行政區法律解釋。
              </li>
            </ul>       
                        </div>  
                        <div className="panel">
                          <p>本人已經細閱及明白本會會員守則之條款及細則和接受該等條款的約束。
                          如閣下違反上述條款，本會可隨時終止對您所提供之所有權益或服務。</p>
                            
                          <label>
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                            />
                              同意
                          </label>                
                        </div>  

                        {/***** Button  ************/}       
                        <div className="registry-form-group">
                          <button type="submit"
                               style={{
                              backgroundColor:'#F01010',
                              color:'#ffffff',
                              padding:'8px 15px',
                              border:'none',
                              borderRadius:'4px',
                              cursor:'pointer',
                              width:'50%',
                            }}>
                            確認
                          </button>
                        </div>    


          </form>   
    
        </div>                    
      </div>                      
    </div>                        
    
  )
}

export default Registry;
